import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import 'dayjs/locale/it';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import {
    TextField,
    MenuItem,
    Button,
    Card,
    CardContent,
    Typography,
    IconButton,
    Box,
    Grid,
    TextareaAutosize,
    Autocomplete,
} from "@mui/material";
import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";
import { createAttrezzature, fetchAttrezzature, updateAttrezzature } from "../../../features/attrezzatura/attrezzaturaThunk";
dayjs.locale('it');
const Textarea = styled(TextareaAutosize)`
    box-sizing: border-box;
    width: 100%;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 12px;
    border-radius: 5px;
    color: #160A2A;
    background: #fff;
    border: 2px solid #e5e5e5;
`;

// Updated EmptyTextarea Component
const EmptyTextarea = ({ placeholder, value, onChange }) => {
    const [inputValue, setInputValue] = useState(value || "");

    useEffect(() => {
        setInputValue(value || "");
    }, [value]);

    const handleChange = (event) => {
        setInputValue(event.target.value);
        onChange(event);
    };

    return (
        <Textarea
            aria-label="empty textarea"
            placeholder={placeholder}
            minRows={4}
            value={inputValue}
            onChange={handleChange}
        />
    );
};

const schema = yup.object().shape({
    nomeAttrezzatura: yup.string().required("Nome dell’attrezzatura è obbligatoria"),
    tipoAttrezzatura: yup.string().required("Tipo di attrezzatura è obbligatoria"),
    marcaModello: yup.string().required("Marca e modello è obbligatoria"),
    // matricola: yup.string().required("Matricola è obbligatoria"),
    anno: yup.number().required("Anno è obbligatoria"),
    stato: yup.string().required("Stato è obbligatoria"),
    ultimaRevisione: yup.date().required("Ultima revisione è obbligatoria"),
    coordinaGPS: yup.string().required("Coordinata GPS è obbligatoria"),
     
});
const options = ["Amministratore", "Collaboratore", "Operatore"];

const AttrezzatureForm = ({ cantine, setCantine, singleData }) => {
    const attrezzatureData = useSelector((store) => store.attrezzature.optionAttrezzature)
    const currentYear = new Date().getFullYear();
    const dispatch = useDispatch()
    const years = Array.from({ length: currentYear - 1900 + 1 }, (_, i) => (currentYear - i).toString());
    const {
        control,
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });
    useEffect(() => {
        if (cantine) {
            // setValue("stabili_id", null);
            setValue("matricola", singleData?.att_name || null);
            setValue("nomeAttrezzatura", singleData?.att_name || null);
            setValue("tipoAttrezzatura", singleData?.attrezzatura || null);
            setValue("marcaModello", singleData?.modello || null);
            setValue("anno", singleData?.suprifice_coperta || null);
            setValue("stato", singleData?.suprificie_stoccaggio || null);
            setValue("ultimaRevisione", singleData?.ultima_date ? dayjs(singleData?.ultima_date) : null);
            setValue("coordinaGPS", singleData?.gps || null);
            setValue("note", singleData?.note || null);
        }
    }, [singleData, setValue])
    const onSubmit = async (data) => {

        let payload = {
            stabili_id: localStorage.getItem('stabili_id'),
            att_name: data.nomeAttrezzatura,
            attrezzatura: data.tipoAttrezzatura,
            modello: data.marcaModello,
            suprifice_coperta: data.anno,
            suprificie_stoccaggio: data.stato,
            ultima_date: data.ultimaRevisione ? dayjs(data.ultimaRevisione).format("YYYY-MM-DD") : null,
            gps: data.coordinaGPS,
            note: data.note
        }
        console.log(payload, "payload1235")
        try {
            const response = !cantine ? await dispatch(createAttrezzature(payload)).unwrap() : await dispatch(updateAttrezzature({ id: singleData.id, data: payload })).unwrap();
            console.log(response, "nature")

            if (response.success) {
                dispatch(fetchAttrezzature());
                setCantine(false)
                localStorage.removeItem("attrezzature")
                // reset({
                //     matricola: "",
                //     tipoAttrezzatura: "",
                //     marcaModello: "",
                //     ultimaRevisione: "",
                //     coordinaGPS: "",
                //     anno: "",
                //     gps: "",
                //     note: "",
                // });
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    return (
        <>
            <form className="AziendaFrom" onSubmit={handleSubmit(onSubmit)}>
                <div className="AziendaFrom__inner">
                    <Controller
                    defaultValue=""
                        name="nomeAttrezzatura"
                        control={control}
                        render={({ field }) => (
                            <TextField className="customTextBox"
                                {...field}
                                value={field.value || ""}
                                label="Nome dell’attrezzatura"
                                fullWidth
                                margin="normal"
                                error={!!errors.nomeAttrezzatura}
                                helperText={errors.nomeAttrezzatura?.message}
                            />
                        )}
                    />
                    <Controller
                    defaultValue=""
                        name="tipoAttrezzatura"
                        control={control}
                        render={({ field }) => (
                            <Autocomplete
                                {...field}
                                options={attrezzatureData}
                                value={field.value || null}
                                onChange={(event, value) => setValue("tipoAttrezzatura", value)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Tipo di attrezzatura"
                                        className="customTextBox autoCompleteTextBox"
                                        margin="normal"
                                        fullWidth
                                        error={!!errors.tipoAttrezzatura}
                                        helperText={errors.tipoAttrezzatura?.message}
                                    />
                                )}
                            />
                        )}
                    />



                    <Controller
                    defaultValue=""
                        name="marcaModello"
                        control={control}
                        render={({ field }) => (
                            <TextField className="customTextBox"
                                {...field}
                                value={field.value || ""}
                                label="Marca e modello"
                                fullWidth
                                margin="normal"
                                error={!!errors.marcaModello}
                                helperText={errors.marcaModello?.message}
                            />
                        )}
                    />

                    {/* <Controller
                    defaultValue=""
                        name="matricola"
                        control={control}
                        render={({ field }) => (
                            <TextField className="customTextBox"
                                {...field}
                                value={field.value || ""}
                                label="Matricola"
                                fullWidth
                                margin="normal"
                                error={!!errors.matricola}
                                helperText={errors.matricola?.message}
                            />
                        )}
                    /> */}
                    <Controller
                    defaultValue=""
                        name="anno"
                        control={control}
                        render={({ field }) => (
                            <Autocomplete
                                {...field}
                                options={years}

                                value={field.value || null}
                                onChange={(event, value) => setValue("anno", value)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Anno"
                                        className="customTextBox autoCompleteTextBox"
                                        margin="normal"
                                        fullWidth
                                        error={!!errors.anno}
                                        helperText={errors.anno?.message}
                                    />
                                )}
                            />
                        )}
                    />
                    <Controller
                    defaultValue=""
                        name="stato"
                        control={control}
                        render={({ field }) => (
                            <TextField className="customTextBox"
                                {...field}
                                value={field.value || ""}
                                label="Stato"
                                fullWidth
                                margin="normal"
                                error={!!errors.stato}
                                helperText={errors.stato?.message}
                            />
                        )}
                    />

                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                        <Controller
                        defaultValue=""
                            name="ultimaRevisione"
                            control={control}
                            render={({ field }) => (
                                <DatePicker
                                    label="Ultima Revisione"
                                    className='datePickerField'
                                    value={field.value ? dayjs(field.value) : null} // ✅ ensure it's dayjs
                                    onChange={(newValue) => field.onChange(newValue ? dayjs(newValue) : null)}
                                />
                            )}
                        />
                    </LocalizationProvider>

                    <Controller
                    defaultValue=""
                        name="coordinaGPS"
                        control={control}
                        render={({ field }) => (
                            <TextField className="customTextBox"
                                {...field}
                                value={field.value || ""}
                                label="Coordina GPS"
                                fullWidth
                                margin="normal"
                                error={!!errors.coordinaGPS}
                                helperText={errors.coordinaGPS?.message}
                            />
                        )}
                    />

                    <Controller
                    defaultValue=""
                        name="note"
                        control={control}
                        render={({ field }) => (
                            <EmptyTextarea placeholder="Note" {...field} />
                        )}
                    />

                    <div className="btnPart1">
                        <Button type="submit" variant="contained">
                            Salva dati
                        </Button>
                    </div>
                </div>
            </form>
        </>
    );
};

export default AttrezzatureForm;
